"use strict";

/// <reference types="jquery"/>
$.datatablesTemplates.push({
    name: "actions",
    callback: function callback(data) {
        return "    <form action=\"/Admin/Gatd/ResetImport/" + data.Id + "\" method=\"post\" class=\"d-inline\">\n                         <button class=\"btn btn-orezo\" type=\"submit\" title=\"Mettre le nombre d'\xE9chec 0\"\n                                 data-toggle=\"modal\"\n                                 data-target=\"#modal\"\n                                 data-title=\"Mettre le nombre d'\xE9chec 0\"\n                                 data-on-done=\"reload\"\n                                 data-modal-body=\"\xCAtes-vous sur de vouloir mettre le nombre d'\xE9chec 0 ?\">\n                             <i class=\"fa fa-undo\"></i>\n                         </button>\n                     </form>\n                     <form action=\"/Admin/Gatd/LaunchImport/" + data.Id + "\" method=\"post\" class=\"d-inline\">\n                         <button class=\"btn btn-orezo\" type=\"submit\" title=\"Relancer l'import\"\n                                 data-toggle=\"modal\"\n                                 data-target=\"#modal\"\n                                 data-title=\"Relancer l'import\"\n                                 data-on-done=\"reload\"\n                                 data-modal-body=\"\xCAtes-vous sur de vouloir relancer l'import ?\">\n                             <i class=\"fa fa-repeat\"></i>\n                         </button>\n                     </form>\n                     <form action=\"/Admin/Gatd/DeleteImport/" + data.Id + "\" method=\"post\" class=\"d-inline\">\n                         <button class=\"btn btn-orezo\" type=\"submit\" title=\"Supprimer\"\n                                 data-toggle=\"modal\"\n                                 data-target=\"#modal\"\n                                 data-title=\"Suppression\"\n                                 data-on-done=\"reload\"\n                                 data-modal-body=\"\xCAtes-vous sur de vouloir supprimer cet import ?\">\n                             <i class=\"fa fa-trash\"></i>\n                         </button>\n                     </form>\n";
    }
});
$.fn.initGestionImports = function () {
    var $container = $(this),
        $table = $container.find("table");
    $(document).on("change", "input[id^=check-type-]", function () {
        var $this = $(this),
            $parent = $this.parents("#filter"),
            datatable = $container.data("datatable"),
            column = datatable.columns($this.data("column") + ":name"),
            checkeds = $parent.find("input:checkbox:checked");
        if (checkeds.length === 0) {
            column.search("");
        } else {
            var values_1 = [];
            checkeds.map(function (i, c) {
                return values_1.push($(c).val());
            });
            column.search(values_1.join(","));
        }
        datatable.page(1);
        datatable.draw();
    });
    $container.setDatatable();
    return $table;
};
$(function () {
    $("div.datatable-imports").initGestionImports();
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/GestionImports/index.ts
// module id = 605
// module chunks = 0